import { getThemeClass, getThemeComponentGroup } from "@/shared/lib/themeComponentClasses";
import { ChevronDown } from "lucide-react";

type AvatarButtonProps = {
  initials: string;
  fullName?: string;
  role?: string;
  menuOpen: boolean;
  onClick: () => void;
};

export function AvatarButton({ initials, fullName, role, menuOpen, onClick }: AvatarButtonProps) {
  const avatarClasses = getThemeComponentGroup("avatar");

  return (
    <button
      onClick={onClick}
      aria-haspopup="true"
      aria-expanded={menuOpen}
      className={`group inline-flex max-w-56 items-center gap-2 rounded-2xl border px-2 py-1 shadow-sm transition-all duration-200 hover:bg-theme-surface hover:shadow-md ${getThemeClass(avatarClasses.buttonBorderColor, "border-theme-border/70")} ${getThemeClass(avatarClasses.buttonBgColor, "bg-theme-surface/80")} ${getThemeClass(avatarClasses.buttonTextColor, "text-theme-text")}`}
    >
      <span
        className={`inline-flex h-8 w-8 items-center justify-center rounded-full text-xs font-bold tracking-wide transition-transform duration-200 group-hover:scale-105 ${getThemeClass(avatarClasses.badgeBgColor, "bg-theme-primary")} ${getThemeClass(avatarClasses.badgeTextColor, "text-theme-text-inverse")}`}
      >
        {initials}
      </span>
      <span className="hidden min-w-0 text-left sm:block">
        <span
          title={fullName || "My account"}
          className="block truncate text-xs font-semibold leading-4"
        >
          {fullName || "My account"}
        </span>
        {role && (
          <span title={role} className="block truncate text-[11px] leading-4 text-theme-text-muted">
            {role}
          </span>
        )}
      </span>
      <ChevronDown
        className={`h-4 w-4 ${getThemeClass(avatarClasses.iconColor, "text-theme-text/70")} transition-transform duration-200 ${
          menuOpen ? "rotate-180" : "rotate-0"
        }`}
      />
    </button>
  );
}
